// extracted by mini-css-extract-plugin
export default {"no_data":"DataTable_no_data__Nf5gn","no_data_text":"DataTable_no_data_text__FPFIF","no_img":"DataTable_no_img__wEH2r"};